import { render, staticRenderFns } from "./survey.vue?vue&type=template&id=06b3a94c&scoped=true"
import script from "./survey.vue?vue&type=script&lang=js"
export * from "./survey.vue?vue&type=script&lang=js"
import style0 from "./survey.vue?vue&type=style&index=0&id=06b3a94c&prod&lang=less&scoped=true"
import style1 from "./survey.vue?vue&type=style&index=1&id=06b3a94c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b3a94c",
  null
  
)

export default component.exports